var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.263C8 12.4721 9.79086 14.263 12 14.263C14.2091 14.263 16 12.4721 16 10.263C16 8.05387 14.2091 6.26301 12 6.26301C9.79086 6.26301 8 8.05387 8 10.263ZM10 10.263C10 11.3676 10.8954 12.263 12 12.263C13.1046 12.263 14 11.3676 14 10.263C14 9.15844 13.1046 8.26301 12 8.26301C10.8954 8.26301 10 9.15844 10 10.263Z",
    fill: "#7E8A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2058 16.5183C21.8058 13.0909 21.9456 7.39409 18.5182 3.79417C15.0908 0.194243 9.39406 0.054383 5.79413 3.48178C2.19421 6.90918 2.05435 12.6059 5.48175 16.2059L11.6876 22.7241L18.2058 16.5183ZM6.93024 14.8268L11.757 19.8965L16.8268 15.0698C19.6267 12.404 19.7355 7.97318 17.0697 5.17324C14.404 2.3733 9.97315 2.26452 7.17321 4.93028C4.37327 7.59603 4.26449 12.0268 6.93024 14.8268Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.425481dd.svg";
export { ForwardRef as ReactComponent };